import { connect } from 'react-redux'
import * as selector from '../../state/detail/selector'
import SentEmailList from '../../../email/component/sent/SentEmailList'


const mapStateToProps = (state, props) => {
    return {
        sentEmailList: selector.selectSentEmailList(state),
    }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(SentEmailList)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/SentEmailWidgetContainer.js